import axios from "axios";

const impressao_socket_api = axios.create({
  baseURL: "https://ws-homolog.inovacode.app.br/",
  // baseURL: "http://localhost:5001/",
});

export default impressao_socket_api;
